import React from 'react';
import { MetaHead } from '../components/MetaHead';
import { COMPANY_INFO, COMMON_CONTACT_CALLOUT } from '../data/scrapedData';

export function ProfessionalPage() {
  return (
    <>
      <MetaHead title="Fagperson - Den Selvejende Institution Midtgaarden" description="Information til sagsbehandlere, kommuner og fagpersoner om visiterede forløb på Midtgaarden." />

      <section className="bg-[#1C1C1E] text-white py-14 sm:py-18">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs uppercase tracking-widest font-semibold text-[#3885B8] block mb-2">
            Visiterende myndigheder
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-white mb-3">
            For fagpersoner
          </h1>
          <p className="text-base sm:text-lg text-white/90 max-w-3xl leading-relaxed">
            Midtgaarden tilbyder omfattende behandlingsforløb til personer med psykiske og sociale udfordringer. Med en holistisk og individuel tilgang arbejder Midtgaarden målrettet for at forbedre livskvaliteten for vores beboere gennem en kombination af terapeutiske og pædagogiske metoder.
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#F8FAFC]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          
          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
              Behandlingstilbud og målgruppe
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1E]/80 leading-relaxed">
              Midtgaarden henvender sig primært til voksne med komplekse psykosociale problemer, herunder psykiske lidelser, misbrugsproblematikker og sociale udfordringer. Institutionens mål er at skabe rammerne for personlig udvikling og social rehabilitering gennem individuelt tilpassede behandlingsforløb.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
              Metodisk tilgang og tværfagligt team
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1E]/80 leading-relaxed">
              Behandlingen på Midtgaarden baserer sig på en tværfaglig og helhedsorienteret tilgang, hvor der arbejdes med både psykisk og fysisk velvære. Institutionen benytter kognitiv terapi, miljøterapi, Dialektisk adfærdsterapi (DAT), CENAPS-modellen og pædagogisk støtte.
            </p>
            <p className="text-sm sm:text-base text-[#1C1C1E]/80 leading-relaxed">
              Personalet består af erfarne psykologer, terapeuter, socialrådgivere, socialpædagoger, sygeplejersker og psykiater.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1E]/10 shadow-xs space-y-4">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4 border-l-4 border-[#1C1C1E] pl-3">
              Samarbejde og netværk
            </h2>
            <p className="text-sm sm:text-base text-[#1C1C1E]/80 leading-relaxed">
              Midtgaarden lægger stor vægt på tæt og gennemskueligt samarbejde med visiterende kommuner, sagsbehandlere, regioner og psykiatrien. Vi udarbejder statusrapporter og handlingsplaner i overensstemmelse med myndighedskrav.
            </p>
          </div>

        </div>
      </section>

      {/* Callout */}
      <section className="py-12 bg-white border-t border-[#1C1C1E]/10">
        <div className="max-w-7xl mx-auto px-4 text-center space-y-4">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1C1C1E] tracking-tight mb-4">{COMMON_CONTACT_CALLOUT.header}</h2>
          <p className="text-sm text-[#1C1C1E]/80 leading-relaxed">{COMMON_CONTACT_CALLOUT.p1}</p>
          <div className="pt-2 flex justify-center gap-4">
            <a href={COMPANY_INFO.phoneTel} className="bg-[#3885B8] hover:bg-[#2A6E9B] text-white px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Ring {COMPANY_INFO.phone}
            </a>
            <a href={COMPANY_INFO.emailMailto} className="border border-[#3885B8] text-[#3885B8] hover:bg-[#3885B8]/10 px-5 py-2.5 rounded-full font-semibold text-sm whitespace-nowrap">
              Skriv til os
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
